import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("el-form", {
    staticClass: "wlc-add-user",
    attrs: {
      "label-width": "80px",
      model: _vm.form
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机区号",
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      filterable: ""
    },
    model: {
      value: _vm.form.phone_prefix,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone_prefix", $$v);
      },
      expression: "form.phone_prefix"
    }
  }, _vm._l(_vm.phonePrefixList, function (item) {
    return _c("el-option", {
      key: item.index,
      attrs: {
        label: "".concat(item.prefix, " - ").concat(item.ch),
        value: item.prefix
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "手机号",
      required: ""
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "姓名",
      required: ""
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "密码",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请填写密码（不低于8位）"
    },
    model: {
      value: _vm.form.password,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "性别",
      required: ""
    }
  }, [_c("el-select", {
    model: {
      value: _vm.form.gender,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "gender", $$v);
      },
      expression: "form.gender"
    }
  }, [_c("el-option", {
    attrs: {
      label: "男",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "女",
      value: "2"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "邮箱"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.mail,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mail", $$v);
      },
      expression: "form.mail"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("提交")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };